module.exports = __webpack_public_path__ + "static/media/tm.9086ab7f.svg";